import { render } from "./Navigation.vue?vue&type=template&id=004eda22&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=004eda22&scoped=true&lang=css"

import exportComponent from "/tmp/pelican-managers-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-004eda22"]])

export default __exports__